module.exports = __webpack_public_path__ + "img/logo-wide.a01aeda9.png";